import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const ShoesAndSocksCopy = () => (
  <Layout1x1>
    <h3 className="text-h2">Tuxedo &amp; Suit Shoes + Formal Socks</h3>
    <Line className="!text-gray-dark" />
    <p className="!mb-64 text-gray-darker">
      Our classy shoes for{' '}
      <Link href="/collection/tuxedos-and-suits" className="tracker-text-shoes_and_socks_collection-230412-132916">
        tuxedos and suits
      </Link>{' '}
      will pair perfectly with your outfit, and our socks range from calm and sophisticated to bright and extravagant.
    </p>

    <h3 className="text-h2">Suit &amp; Tuxedo Shoes</h3>
    <Line className="!text-gray-dark" />
    <p className="!mb-64 text-gray-darker">
      Check out our suit and tuxedo shoe rental options to complete your look! Nothing ties together an elegant outfit like a grounding pair
      of shoes.
    </p>

    <h3 className="text-h2">Formal Socks</h3>
    <Line className="!text-gray-dark" />
    <p className="text-gray-darker">
      Browse our wide selection of suit and tuxedo socks. You can choose to stay classy with solid colors and{' '}
      <Link
        href="/collection/shoes-and-socks/sangria-and-midas-gold-black-argyle-socks"
        className="tracker-text-shoes_and_socks_collection-230412-133106"
      >
        argyle
      </Link>
      , go bold and sport your{' '}
      <Link
        href="/collection/shoes-and-socks/stance-celtics-shortcut-2-crew-socks"
        className="tracker-text-shoes_and_socks_collection-230412-133329"
      >
        favorite team
      </Link>
      , geek out on your{' '}
      <Link
        href="/collection/shoes-and-socks/stance-star-wars-lord-vadar-socks"
        className="tracker-text-shoes_and_socks_collection-230412-133403"
      >
        favorite movie
      </Link>
      , or choose a cool pattern and design of your choice! Even if you’re the only one who sees them, you can stand with pride knowing that
      you’re wearing the coolest socks around.
    </p>
  </Layout1x1>
);

export default ShoesAndSocksCopy;
